import React from "react";

import {
  InfoIcon,
  AlertTriangleIcon,
  AlertCircleIcon,
  CheckCircleIcon,
} from "lucide-react";

import type { CalloutVariant } from "./Callout";

export const VARIANT_CONFIG: Record<
  CalloutVariant,
  {
    container: string;
    icon: React.ComponentType<{ className?: string }>;
  }
> = {
  info: {
    container: "border border-info-border bg-info text-info-foreground",
    icon: InfoIcon,
  },
  warning: {
    container:
      "border border-warning-border bg-warning text-warning-foreground",
    icon: AlertTriangleIcon,
  },
  danger: {
    container: "border border-error-border bg-error text-error-foreground",
    icon: AlertCircleIcon,
  },
  success: {
    container:
      "border border-success-border bg-success text-success-foreground",
    icon: CheckCircleIcon,
  },
};
